import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const links = [
  { to: "/#services", label: "Services" },
  { to: "/residential", label: "Residential" },
  { to: "/commercial", label: "Commercial" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      className="fixed inset-x-0 top-0 z-50 border-b border-[#16241C]/10 bg-white"
      data-testid="main-nav"
    >
      <div className="relative mx-auto flex h-[76px] max-w-[1160px] items-center justify-between px-5 md:px-8">
        <Link to="/" data-testid="nav-logo" aria-label="Legacy Scapes home">
          <img src="/logo.png" alt="Legacy Scapes Ltd." className="h-11 w-auto" />
        </Link>

        <nav className="hidden items-center gap-7 lg:flex">
          {links.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-bold text-[#16241C] transition-colors duration-300 hover:text-[#043B1C]"
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/contact"
            data-testid="nav-quote-button"
            className="rounded-full bg-[#043B1C] px-6 py-2.5 text-sm font-bold text-white transition-colors duration-300 hover:bg-[#F4BE36] hover:text-[#043B1C]"
          >
            Request an Estimate
          </Link>
        </nav>

        <div className="flex items-center gap-3 lg:hidden">
          <Link
            to="/contact"
            data-testid="nav-quote-button-mobile"
            className="rounded-full bg-[#043B1C] px-5 py-2 text-xs font-bold text-white transition-colors duration-300 hover:bg-[#F4BE36] hover:text-[#043B1C]"
          >
            Request an Estimate
          </Link>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            className="text-[#16241C]"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.25 }}
            className="border-b border-[#16241C]/10 bg-white lg:hidden"
            data-testid="nav-mobile-menu"
          >
            <div className="flex flex-col px-5 py-4">
              {links.map((l) => (
                <Link
                  key={l.label}
                  to={l.to}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                  className="border-b border-[#16241C]/5 py-4 text-base font-bold text-[#16241C]"
                >
                  {l.label}
                </Link>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
